export const formFields = [
  {
    key: 'name',
    label: 'Business Function',
    isRequired: true,
  },
  {
    key: 'description',
    label: 'Description',
    isRequired: false,
    type: 'textArea',
  },
];
